import { render, staticRenderFns } from "./EditCampaignGroupModal.vue?vue&type=template&id=54f58e34"
import script from "./EditCampaignGroupModal.vue?vue&type=script&lang=js"
export * from "./EditCampaignGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditCampaignGroupModal.vue?vue&type=style&index=0&id=54f58e34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports